import React from 'react';
import Modal from 'react-modal';

type PrivacyPolicyModalProps = {
    openState: boolean;
    setOpenState: (value: boolean) => void;
};

export const PrivacyPolicyModal: React.FC<PrivacyPolicyModalProps> = ({ openState, setOpenState }) => {
    return (
        <Modal
            isOpen={openState}
            onAfterOpen={() => setOpenState(true)}
            onRequestClose={() => setOpenState(false)}
            className={'modal-card'}
            id={'p_poly'}
            overlayClassName={'modal-overlay'}
            ariaHideApp={false}
        >
            <header className='modal-card-head'>
                <p className='modal-card-title'>データライブ株式会社 個人情報保護方針</p>
                <button className='delete' aria-label='close' onClick={() => setOpenState(false)}>
                    <span>CLOSE</span>
                </button>
                <p className='modal-card-subtitle'>tutorial</p>
            </header>
            <section className='modal-card-body'>
                <div className='content'>
                    <div className='columns'>
                        <div className='column'>
                            <h3>1. 個人情報保護の理念</h3>
                            <p>
                                個人情報は、個人の人格尊重の理念の下に慎重に取り扱われるべきものである。
                                <br />
                                当社の業務を遂行するにあたり、個人情報は法令を遵守し、安全かつ適正な取扱が図られなければならない。
                            </p>
                            <hr />
                            <h3>2. 基本方針</h3>
                            <p>
                                個人情報は個人の貴重な財産である。データライブ株式会社で業務に従事するすべての者は、個人情報保護方針（以下、「本方針」という。）に基づき、個人情報保護管理を実施・維持し、個人情報を正確かつ安全に取り扱わなければならない。
                            </p>
                            <hr />
                            <h3>3. 個人情報保護管理の目的</h3>
                            <p>
                                (1)適切な個人情報の取得、利用及び提供の基準と、これを運用する規程を定める。
                                <br />
                                (2)個人情報への不正アクセス、個人情報の漏えい、滅失又はき損の防止及び是正に関する行動規範、具体的ルールを定める。
                            </p>
                            <hr />
                            <h3>4. 組織活動 </h3>
                            <p>
                                個人情報保護管理を具体化するため以下の活動を行う。
                                <br />
                                (1)個人情報保護統括責任者を選任し、個人情報保護管理の確立、実施および維持に関する責任および権限を与える。
                                <br />
                                (2)個人情報保護に係る統括責任部署を設置する。
                                <br />
                                (3)個人情報保護活動の遂行に責任を負う個人情報保護管理責任者を置く。
                                <br />
                                (4)内部監査に基づき、社内の規程、運用の仕方を改善する。
                                <br />
                                (5)取引のある企業及び個人に対し、規程の目的達成のための協力を要請する。
                                <br />
                                (6)「本方針」は、当社のウェブサイト(URL : https://www.datalive.co.jp)
                                、会社案内等に掲載することにより、いつでも閲覧可能な状態とする。
                                <br />
                                (7)個人情報の取扱い及び個人情報保護管理に関して、本人からの苦情及び相談を受け付ける「個人情報苦情相談窓口」を設け、適切かつ迅速に対応する。
                                <br />
                                (8)役員及びすべての従業者は、個人情報の保護に関する法律、個人情報に関する法令、所管省庁が作成したガイドライン・指針及びその他の規範を遵守する。
                                <br />
                                (9)個人情報保護管理は運用の確認、監査、是正処置及び予防処置などを行い、継続的に改善する。
                            </p>
                            <hr />
                            <h3>5. 個人情報の取り扱い</h3>
                            <p>
                                (1)個人情報の取得・利用・提供について
                                <br />
                                当社は業務遂行に際して、適切な個人情報の取得、利用及び提供を行う。また本人に対し利用目的を明らかにするとともに、利用目的は当社のウェブサイト上に公表する。明示した利用目的以外の利用は行わない。またそのための措置を講じる。
                                <br />
                                (2)権利の尊重
                                <br />
                                当社は、個人情報に関する個人の権利を尊重し、自己の個人情報に対し、本人から利用目的の通知、開示、内容の訂正、追加又は削除、利用の停止、消去及び第三者への提供の停止を求められたときは、合理的な期間、妥当な範囲内でこれに応ずる。
                                <br />
                                (3)安全対策の実施
                                <br />
                                当社は、社内規程を整備し、全従業者に個人情報保護に関する教育を実施する他、個人情報への不正アクセス、個人情報の漏えい、滅失又はき損の予防並びに是正に関する物理的及び技術的措置を講じ、適切な安全対策を実施する。
                            </p>
                            <hr />
                            <h3>6. マイナンバーについて</h3>
                            <p>
                                上記「個人情報保護方針」の定めにかかわらず、いわゆる「マイナンバー」を含む個人情報（特定個人情報）については、
                                関連する規程および法令、その他の規範に従い適切に取り扱う。
                            </p>
                            <hr />
                            <p className='has-text-centered has-text-left-touch is-block mb-6 mt-1'>
                                当社は以上の方針を改定することがあります。その場合すべての改定はこのウェブサイトで通知いたします。
                            </p>

                            <h2 className='has-text-dl-blue'>個人情報利用目的</h2>

                            <h3>1. 従業者から取得する目的</h3>
                            <p>
                                (1)給与計算業務を行なうため。　(2)社会保険業務を行なうため。　(3)労務管理業務、緊急時の連絡、案内を行なうため。　(4)採用活動及び社内外に対する広報活動を行うため。
                            </p>
                            <hr />
                            <h3>2. 採用応募者から取得する目的</h3>
                            <p>(1)応募者を採用するか、否かを判断するため。</p>
                            <hr />
                            <h3>3. お客様から取得する目的</h3>
                            <p>
                                (直接ご本人から取得する場合及び公開情報・第三者等から間接的に取得する場合を含む) <br />
                                (1)商品・サービス・サポートのご提案・販売・提供　(2)商品・サービス等のサポート対応　(3)当社の取扱う商品・サービス等のご案内　(4)当社が開催（主催、共催、協賛）するイベント（各種セミナー、展示会他）等のご案内　(5)『メルマガ』等の刊行物の発送　(6)お客様との連絡、商談、打ち合わせ、契約の履行等　(7)お客様からのお問合せやご依頼への対応　(8)各種アンケートの実施
                            </p>
                            <hr />
                            <h3>4. お取引先様から取得する目的</h3>
                            <p>
                                (1)お取引先様との連絡、商談、打ち合わせ、契約の履行　(2)お取引先様からのお問合せやご依頼への対応
                            </p>
                            <hr />
                            <h3>5. 協力会社様から取得する目的</h3>
                            <p>(1)協力会社員との業務遂行に係わる連絡、打ち合わせ、契約の履行</p>
                            <hr />
                            <h3>6. 当社ウェブサイト上におけるご利用者様の個人情報の保護について</h3>
                            <p>
                                通常、ご利用者様は、ご自身の個人情報を一切明かすことなく、当社のウェブサイトにアクセスすることができます。ただし、ご利用者様から個人情報をご提供して頂けない場合には、ご覧頂けないコンテンツやご利用頂けないサービスがあることをあらかじめご了承願います。
                                <br />
                                (1)通信途上での盗難防止（SSL）について
                                お問合せ、お申込み等でご提供いただくご利用者様の個人情報は、SSLによって暗号化され保護されます。
                                SSLに対応していないブラウザをご利用の場合は、当社のウェブサイトにアクセスできない場合や情報の入力ができない場合があります。
                                <br />
                                (2) IPアドレス等の利用について
                                当社ウェブサイトへのアクセスの傾向を分析するため、また、当社ウェブサイトで発生した問題を解決するために、アクセスのなされたIPアドレス、ドメインを記録することがあります。しかし、そのようなデータからは、ご利用者様個人を特定することはできません。
                                <br />
                                (3)CookieおよびWebビーコン（透過GIF）について
                                Webビーコンによる統計データは、当ウェブサイトの機能向上又は当社のサービス向上若しくは業務の改善などの目的に利用させていただくものです。WebビーコンとCookieとを合わせて使用することにより、詳細な統計的情報を取得することができるようになります。取得した情報には閲覧したユーザーの属性集計や利用状況集計が含まれていますが、個別のユーザーを特定するような情報は一切含んでいません。
                                <br />
                                ※「Cookie（クッキー）」
                                ご利用者様の情報をブラウザ内に保存することで、再入力の手間を省き、ご利用者様にとって最適なコンテンツを表示することができる機能。ご利用者様は、ブラウザの設定により、Cookieの受け取りを拒否したり、Cookieを受け取ったとき警告を表示させたりできます。但し、その場合はウェブサイト上のサービスの全部または一部が使えないなどの制約が生じることがあります。
                                <br />
                                ※「Webビーコン」ご利用者様のパソコンからのアクセス状況を把握して、特定のWebページの使用率等に関する統計を取ることができる技術（”クリアGIF”と称されることもあります）。
                            </p>
                            <hr />
                            <div className='syomei'>
                                <p>
                                    2008年9月20日
                                    <br />
                                    一部改正: 2021年7月1日
                                    <br />
                                    一部改正: 2022年7月1日
                                    <br />
                                    データライブ株式会社 代表取締役　山田　和人
                                </p>
                            </div>
                            <div className='kujo'>
                                <h3>
                                    本内容に関するご質問及び苦情・開示等に関するご相談は「個人情報苦情相談窓口」にお願い致します。
                                </h3>
                                <p>
                                    <strong>
                                        データライブ株式会社
                                        <br className='is-hidden-tablet' />
                                        「個人情報苦情相談窓口」
                                    </strong>
                                    <br />
                                    【所在地】
                                    <br className='is-hidden-tablet' />
                                    東京都中央区八丁堀 3-3-5 住友不動産八丁堀ビル8階
                                    <br />
                                    【電話番号】
                                    <br className='is-hidden-tablet' />
                                    03-5684-5419　
                                    <br className='is-hidden-desktop' />
                                    【E-mail】
                                    <br className='is-hidden-tablet' />
                                    privacy@datalive.co.jp
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </Modal>
    );
};
